import {
  CardStyleInterpolators,
  createStackNavigator,
  StackScreenProps,
} from "@react-navigation/stack";
import { Spacings } from "react-native-ui-lib";
import { ModalCloseButton } from "@towersystems/roam-common-native";
import {
  RegisterRootParamList,
  SerialNumberRootParamList,
} from "../../../../types";
import { useTheme } from "@towersystems/roam-common-native";
import { AddSerialNumberProductScreen } from "../AddSerialNumberProductScreen";
import { ListProductSerialNumbersScreen } from "../ListProductSerialNumbersScreen";

export type SerialNumberRootScreenProps = StackScreenProps<
  RegisterRootParamList,
  "SerialNumberRootScreen"
>;

export const SerialNumberRootScreen = ({}: SerialNumberRootScreenProps) => {
  const { colors: Colors } = useTheme();
  const Drawer = createStackNavigator<SerialNumberRootParamList>();

  return (
    <Drawer.Navigator>
      <Drawer.Group
        screenOptions={{
          headerShown: true,
          gestureEnabled: false,
          animationEnabled: true,
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          headerLeft: () => <ModalCloseButton type="Back" />,
          cardStyle: {
            backgroundColor: Colors.surface,
          },
          headerLeftContainerStyle: { paddingLeft: Spacings.s5 },
          headerRightContainerStyle: { paddingRight: Spacings.s5 },
          headerTintColor: Colors.text,
          headerTitleAlign: "center",
          headerStyle: {
            backgroundColor: Colors.surface,
            borderBottomWidth: 1,
            borderBottomColor: Colors.borderColor,
          },
          presentation: "modal",
        }}
      >
        <Drawer.Screen
          name="ListProductSerialNumbersScreen"
          component={ListProductSerialNumbersScreen}
          options={{
            headerLeft: () => <ModalCloseButton type="Close" />,
            title: "Serial Number Required",
          }}
        />
        <Drawer.Screen
          name="AddSerialNumberProductScreen"
          component={AddSerialNumberProductScreen}
          options={{ title: "New  Serial Number" }}
        />
      </Drawer.Group>
    </Drawer.Navigator>
  );
};
